import { FormatDateBR } from "src/shared/Utils/FormatDateBR";

export const FormatLogValue = (value: any) => {
  if (value === null || value === undefined || value === "") return "-";
  if (typeof value === "boolean") return value ? "Sim" : "Não";
  if (typeof value === "object") return JSON.stringify(value, null, 2);

  const str = String(value);

  if (/^\d{4}-\d{2}-\d{2}(T.*)?$/.test(str)) {
    return FormatDateBR(str);
  }

  return str;
};